import { IAsyncState } from '@domain/store/async';
import { createReducer, on } from '@ngrx/store';
import {
    followActions,
    loadActions,
    showcaseFollowActions,
    showcaseLoadActions,
    showcaseUnfollowActions,
    unfollowActions
} from './follow-creativeset.actions';

export const FOLLOW_CREATIVESET_FEATURE_KEY = 'followCreativeSet';

export interface FollowCreativeSetPartialState {
    readonly [FOLLOW_CREATIVESET_FEATURE_KEY]: FollowCreativeSetState;
}

export interface FollowCreativeSetState extends IAsyncState {
    isFollower: boolean;
    userEmail: string | undefined;
    userName: string | undefined;
}

export const initialState: FollowCreativeSetState = {
    loaded: false,
    isFollower: false,
    userEmail: undefined,
    userName: undefined
};

export const reducer = createReducer<FollowCreativeSetState>(
    initialState,

    on(loadActions.load, showcaseLoadActions.load, (state, action) => {
        return {
            ...state,
            loaded: false,
            error: undefined,
            creativeSetId: action.creativeSetId
        };
    }),

    on(showcaseLoadActions.load, (state, action) => {
        return {
            ...state,
            userEmail: action.userEmail ?? ''
        };
    }),

    on(
        loadActions.loadFailure,
        followActions.followFailure,
        unfollowActions.unfollowFailure,
        showcaseLoadActions.loadFailure,
        showcaseFollowActions.followFailure,
        showcaseUnfollowActions.unfollowFailure,
        (state, { error }) => {
            return {
                ...state,
                loaded: true,
                error
            };
        }
    ),
    on(followActions.followFailure, showcaseFollowActions.followFailure, (state, { error }) => {
        return {
            ...state,
            loaded: true,
            error,
            isFollower: false // optimistic rendering - fallback
        };
    }),

    on(unfollowActions.unfollowFailure, showcaseUnfollowActions.unfollowFailure, (state, { error }) => {
        return {
            ...state,
            loaded: true,
            error,
            isFollower: true // optimistic rendering - fallback
        };
    }),

    on(loadActions.loadSuccess, (state, { isFollower }) => {
        return {
            ...state,
            loaded: true,
            isFollower
        };
    }),

    on(followActions.follow, showcaseFollowActions.follow, state => {
        return {
            ...state,
            error: undefined,
            isFollower: true // optimistic rendering
        };
    }),

    on(unfollowActions.unfollow, showcaseUnfollowActions.unfollow, state => {
        return {
            ...state,
            error: undefined,
            isFollower: false // optimistic rendering
        };
    }),

    on(followActions.followSuccess, showcaseFollowActions.followSuccess, state => {
        return {
            ...state,
            loaded: true,
            isFollower: true
        };
    }),

    on(unfollowActions.unfollowSuccess, showcaseUnfollowActions.unfollowSuccess, state => {
        return {
            ...state,
            loaded: true,
            isFollower: false
        };
    }),

    on(showcaseLoadActions.init, (state, { creativeSetId }) => {
        return {
            ...state,
            creativeSetId
        };
    }),

    on(showcaseLoadActions.initSuccess, (state, { creativeSetId, userEmail, userName }) => {
        return {
            ...state,
            creativeSetId,
            userEmail,
            userName
        };
    })
);
